import { memo, useState } from 'react'
import { StyleSheet } from 'react-native'
import { Chip, useTheme } from 'react-native-paper'
import { AuditHistoryDialog } from './AuditHistoryDialog'

interface AdminEditedChipProps {
    timeEntryId: string
}

export const AdminEditedChip = memo(function AdminEditedChip({
    timeEntryId,
}: AdminEditedChipProps) {
    const theme = useTheme()
    const [showHistory, setShowHistory] = useState(false)

    return (
        <>
            <Chip
                mode="outlined"
                icon="account-edit"
                onPress={() => setShowHistory(true)}
                style={[styles.chip, { borderColor: theme.colors.tertiary }]}
                textStyle={{ color: theme.colors.tertiary, fontSize: 11 }}
                compact
            >
                Edited
            </Chip>
            <AuditHistoryDialog
                visible={showHistory}
                timeEntryId={timeEntryId}
                onDismiss={() => setShowHistory(false)}
            />
        </>
    )
})

const styles = StyleSheet.create({
    chip: {
        alignItems: 'center',
        display: 'flex',
    },
})
